import React, { useEffect } from 'react';
import { Form, FormInstance, Input, Select, Switch } from 'antd';

import PageFormPages from '../../Pages/Form';
import { useCountriesGet } from '../../../../hooks/api/countries';
import { Option } from '../../../../types';

import styles from '../../Categories/[categoryId]/SubCategories/Common/index.module.scss';

export interface PageFormProps {
  loading?: boolean;
  form: FormInstance;
  onChange: () => void;
}

// isActive: boolean;
// key: string;
// name: string;
// title: string;
// description: string;
// keywords: string;
// data: AnyObject;

export default function PageForm({ loading, form, onChange }: PageFormProps): JSX.Element {
  const countriesGet = useCountriesGet();

  useEffect(() => {
    countriesGet.fetch({
      page: 1,
      pageSize: 300,
    });
  }, []);

  return (
    <div style={{ maxWidth: 600 }}>
      <Form.Item label="Country" style={{ marginBottom: 0 }}>
        <Form.Item
          name="countryId"
          label="Country"
          rules={[{ required: true, message: 'Please select country!' }]}
          style={{ display: 'inline-block', width: 'calc(100% - 104px)' }}
        >
          <Select
            disabled={loading || countriesGet.loading}
            loading={countriesGet.loading}
            placeholder="Select country"
            showSearch
            optionFilterProp="children"
            options={countriesGet.data?.data.map((country) => ({
              value: country.id,
              label: country.name,
              country,
            }))}
            filterOption={(input: string, option?: Option) => {
              const country = countriesGet.data?.data.find(({ id }) => id === option?.value);

              if (country) {
                const inputLowerCase = input.toLowerCase();

                return (
                  country.iso3.toLowerCase().includes(inputLowerCase)
                  || country.name.toLowerCase().includes(inputLowerCase)
                );
              }

              return false;
            }}
          />
        </Form.Item>
        <div className={styles.inline} style={{ width: '80px', margin: '0 0 0 24px' }}>
          <Form.Item
            label="Active"
            name="isActive"
            initialValue={false}
            rules={[{ required: false }]}
            style={{ display: 'inline-block', marginLeft: 8 }}
          >
            <Switch onChange={() => (onChange ? onChange() : undefined)} />
          </Form.Item>
        </div>
      </Form.Item>
      <Form.Item label="Description" name="description" rules={[{ max: 1000 }]}>
        <Input.TextArea rows={3} placeholder="Description" />
      </Form.Item>

      <br />
      <h3>SEO section</h3>

      <PageFormPages group="seo" form={form} />
    </div>
  );
}
